<template>
  <div>
 
 


 



  
   <div v-if='!loadstatus' style="z-index:100000000000000;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.3)" class="d-flex align-items-center justify-content-center">
   
   <div style="width:100px;">
     <img src="https://shop.websitelearners.com/static/img/loader.0395a07.gif" class="img-fluid" style="width:100%">
   </div>
 </div>




  <div v-else>





 
<div style="z-index: 10000;position: fixed;bottom: 0;left: 0;right: 0;padding:10px 27px;background: #fff;box-shadow:rgb(0 0 0 / 20%) 0px 2px 4px -1px, rgb(0 0 0 / 14%) 0px 4px 5px 0px, rgb(0 0 0 / 12%) 0px 1px 10px 0px" class="d-md-none d-flex align-items-center justify-content-between">


  






  <div
 
v-bind:class="[{ botactive: $route.path.toLowerCase()=='/'+info.name.toLowerCase()},{ botnotactive: $route.path.toLowerCase()!='/'+info.name.toLowerCase() },{navclass:true}]"  >


    <router-link to='/' style='text-decoration:none'>

 <img src="./images/files/homeblack.svg" style="transform:translateY(-1px)" >



</router-link>
</div>


 
 





   <div  class="botnotactive navclass"   style="position:relative">
    <router-link  to='/bag'  style='text-decoration:none'>

<div style="width:16px;height:16px;background:#EB3838;border-radius:50%; z-index:10000;   position: absolute;
    top: 3px;
    right: 4px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:10px;font-weight:700">{{rendercartlength}}</span>
</div>
 <img src="./images/files/bagbottom.svg"  style="width:20px;transform:translateY(-1px)" >

  </router-link>
  </div>




   <div   class="botactive navclass"   v-on:click='account'>
        

 <img src="./images/files/userwhite.svg" style="width:20px;transform:translateY(-1px)"   >
 
  </div>
   
</div>

<!--headerr--> 


 





 

<div  class="  pt-md-4 pb-md-4 pt-3 pb-3  headerwrapper" style="position:sticky;top:0px;background:#fff;z-index:10000000">
  <div class="container  ">

  <div class="headerui     ">
  
    <router-link  to='/'  style='text-decoration:none'>
<div class="d-flex align-items-center mr-4  logowrapper">
  <div class="imgwrapui"> 
    <img :src="info.logo"  class="img-fluid" style="position:relative;z-index:10000000" >
  </div>
  <div>
    <p class="businessname">{{info.name}}</p>
    <div class="d-none align-items-center">
      <i class='bx bxs-badge-check verifiedicon' ></i>
      <p class="verified">Trusted Seller</p>

    </div>

  </div>
</div>
</router-link>

<div style="position:fixed;top:0;left:0;right:0;bottom:0px;background:rgba(0,0,0,0.3);z-index:100000000;cursor:pointer"  class="d-md-block d-none" v-if='opacitybox'  v-on:click='opacitybox=false' ></div>



 
 







<div class="d-flex align-items-center  navwrapper  ml-3   ">
  

  <div class="d-none align-items-center contactwhatsapp" style="">
    
    <img src="https://cdn.usbrandcolors.com/images/logos/whatsapp-logo.svg" style="width:20px;margin-right:6px;min-width:20px;">

 <p style="font-weight:600;color:#fff;font-size:13px">WhatsApp</p>

  </div>
 
  <router-link   to='/bag'   style='text-decoration:none'>
  <div class="d-flex align-items-center navitem pl-4 ml-4" style="position:relative">
    
          <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>


    <div style="width:16px;height:16px;background:#EB3838;border-radius:50%;    position: absolute;
    top: 2px;
    right: 10px;" class="d-flex align-items-center justify-content-center" v-if='carts.length'>
  <span style="margin:0!important;color:#fff;font-size:11px;font-weight:600">{{rendercartlength}}</span>
</div>



 <svg width="17" height="20" viewBox="0 0 17 20" fill="#0B0A23" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.7" d="M15 5.83333H11.6667V3.33333C11.6667 1.4925 10.1742 0 8.33333 0C6.4925 0 5 1.4925 5 3.33333V5.83333H1.66667L0 20H16.6667L15 5.83333ZM5.83333 3.33333C5.83333 1.955 6.955 0.833333 8.33333 0.833333C9.71167 0.833333 10.8333 1.955 10.8333 3.33333V5.83333H5.83333V3.33333ZM5 7.5V8.75C5 8.98 5.18667 9.16667 5.41667 9.16667C5.64667 9.16667 5.83333 8.98 5.83333 8.75V7.5H10.8333V8.75C10.8333 8.98 11.02 9.16667 11.25 9.16667C11.48 9.16667 11.6667 8.98 11.6667 8.75V7.5H13.5183L13.9108 10.8333H2.75667L3.14917 7.5H5Z" fill="#0B0A23"/>
</svg>

 


  </div>
</router-link>
  <div class="d-flex align-items-center    " style="position:relative;padding-left:50px"  >
      
      <div style="position:absolute;left:0;height:20px;width:1px;background:#e8e9f1;opacity:0.4"></div>

      <p class="mya" style="color: #0B0A23;

opacity: 0.8;font-weight: 500;
font-size: 14px;" v-on:click='account'>My Account</p>

<div v-if='user' style="position:absolute;top:0px;left:50%;transform:translateX(-50%);padding-top:40px;cursor:pointer" class="opanav">


  <div style="width:170px;background:#fff;border-radius:4px;box-shadow:0 0 10px rgba(0,0,0,0.1)">

    <router-link to='/whishlist' style='text-decoration:none'>
    <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Wishlist</p>
  </router-link>
   <router-link to='/account' style='text-decoration:none'>
       <p class="navhover" style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Account</p>
     </router-link>
          <p class="navhover"   v-on:click='logout' style="color: #0B0A23;opacity: 0.8;font-weight: 500;font-size: 14px;padding:10px ;border-bottom:1px solid #fafafa">Logout</p>
  </div>
</div>


  </div>




</div>

</div>

  </div>
  
</div>



 









 

<div class="pt-md-4 pb-md-5 pt-0 pb-3  headerwrapper2  " style="background:#fff!important;min-height:100vh">
  <div class="container pads ">
  <div class="   ">





<div class="row justify-content-center">
  
  <div class="col-md-8 mobcol" >
    <div style="border:none!important" class="orderwrapper ordersuc">


 


<div  class="px-md-5 pt-md-4 p-0"   v-if='cancelled'>
 
 <div class= "p-0 p-0 "  style="text-align: center;">



                 <div  style="" >

<div class="d-md-flex d-none align-items-center justify-content-center    "  >
   
 
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Order Cancelled
</p>


</div>


<div class="d-md-none d-flex align-items-center justify-content-start    "  >
  
   <svg width="21"  v-on:click="tab='address'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>




<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Order #{{actualorders[0].orderid}}
</p>


</div>



<div class="d-flex align-items-center justify-content-center">
  

    <div style="" class=" sucball d-flex align-items-center justify-content-center">
      <svg width="35" height="30" viewBox="0 0 35 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 15.1669L2.96813 12.4219C6.44438 14.1019 8.64563 15.3806 12.5494 18.165C19.8919 9.83625 24.7425 5.61 33.7594 0L34.725 2.22375C27.2906 8.71125 21.8438 15.9375 14.0044 30C9.16875 24.3037 5.94 20.6737 0 15.1669Z" fill="white"/>
</svg>

    </div>
    </div>


          <p style=" " class="ordersuctext"  >Your order is Cancelled!</p>
                        </div>
                           <p   style="" class="subtxt">You Order will be Cancelled. For more details, Click Check Status </p>  

                            <div class="d-flex flex-wrap   " style=" margin-top:46px" >
                            <div style="" class="statusbtn">
                             <div style="" class="leftshop"  v-on:click='checkstatus'  >

                                Check Status
                              </div>
                            </div>

                            <div style="   " class="statusbtn" >
                              <div style="" class="rightshop"  v-on:click='gohome' >
                                Continue Shopping
                              </div>
                                
                            </div>
                      
                           </div>   






              
                        



             </div>

</div>





      
      <div v-if=' actualorders!=null && !cancelled' style="padding:8px">





            <div>
              



<div class="d-flex align-items-center mt-md-5 mb-md-5 mb-3 mt-md-3 mt-0    recan" >
  
  <svg width="21"  v-on:click="tab='bag'" height="14" viewBox="0 0 21 14" style='cursor:pointer' fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.363604 6.3636C0.012132 6.71508 0.012132 7.28492 0.363604 7.6364L6.09117 13.364C6.44264 13.7154 7.01249 13.7154 7.36396 13.364C7.71543 13.0125 7.71543 12.4426 7.36396 12.0912L2.27279 7L7.36396 1.90883C7.71543 1.55736 7.71543 0.987511 7.36396 0.636039C7.01249 0.284567 6.44264 0.284567 6.09117 0.636039L0.363604 6.3636ZM1 7.9H21V6.1H1V7.9Z" fill="#0B0A23"/>
</svg>
<p  class="shopbag" style="margin-left:20px;margin-top:0px!important" >Request Cancellation
</p>


</div>


        
            <div class="d-flex align-items-center justify-content-between">
              <p  class="itmtxt" style="color:rgb(11, 10, 35);font-weight:600" >Order #{{actualorders[0].orderid}}</p>
              <p class="itmtxt"  style="color:#EB3838;font-weight:600;font-size:18px" id="itmtot">₹{{actualorders[0].total}}</p>
            </div>
             <div class="d-flex align-items-center justify-content-between mt-1">
              <p style="color:#8c8e9c;font-size:14px;font-weight:400">{{actualorders[0].items.length}} Item</p>
              <p style="color:#8c8e9c;font-size:14px;font-weight:400">{{renderdate(actualorders[0].date)}}</p>
            </div>
          </div>
                  <div style="height: 1px;background: rgb(230 231 238 / 50%);margin-top: 20px;"></div>

          <p class="itemtitle">Reason for Cancellation</p>

          
   <div class="mt-4">
        
  <template v-for='itm in filters'>



      <div class="d-flex align-items-center my-3" style="cursor:pointer" v-on:click='filterorder(itm)'>
           <div v-if='itm.selected' style="width:22px;height:22px;border-radius:30px;border:1px solid rgb(246 74 84 / 90%);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                              <div style="width:14px;height:14px;border-radius:30px;background:rgb(246 74 84 / 90%)"></div>
                            </div>

                              <div v-else style="width:22px;height:22px;border-radius:30px;border:1px solid rgba(166, 166, 192, 0.6);background:background:rgba(255,255,255,0.6);margin-top: 2px;" class="d-flex align-items-center justify-content-center">
                             
                            </div>
        <p style="margin-left:13px;color:#0B0A23;font-size:18px;font-weight:300;font-family: Nunito, sans-serif;opacity:0.6">{{itm.name}}</p>
      </div>
    </template>
    </div>

<div class="d-flex align-items-center  mt-5">
  <div style="color:#fff;background:#EB3838;padding:10px 20px;border-radius:5px;cursor:pointer;font-weight:600" v-on:click='cancelorder'>Cancel Order</div>
</div>


 


 


      </div>
   
 

 
</div>

  </div>
</div>





 



 
 </div>

  </div>
  
</div>
 

 
 


 






 
 </div>

  
  </div>
</template>

<script>
 import firebase from 'firebase'

 
const fb = require('./firebaseconfig.js')
 
export default {
        props: ['loadstatus','info','products','category','deals','addcart','test','carts','orders','uids'],

  
  data () {

        return{

 sendotpclicked:false,
       otpenterd:true,
       otpvalue:'',
            loaded:false,
            actualorder:null,
            cancelled:false,
            user:false,
               filters:[
            {
              name:'I ordered it by mistake',
              selected:true
            },
            {
              name:'I want to change my delivery address',
              selected:false,
            },
            {
              name:'Price for the product has decreased',
              selected:false,
            },
            {
              name:'I have changed my mind',
              selected:false,
            }, {
              name:'Other',
              selected:false,
            },
            ],

            singleorder:[],
            singdes:false,
            auth:false,
            actloaded:false

        }
     
    
  },
  created(){
  var vm=this;
 
 if(firebase.auth().currentUser){



  this.auth=true
    this.user=true
 }else{
  this.auth=false
      this.user=false
 }


 

 
   
 
     fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('orders').where("orderid", "==", Number(vm.$route.params.orderid)).onSnapshot(querySnapshot=>{
 
    querySnapshot.forEach((doc)=> {
      
 
 
  vm.singdes=true
    vm.actloaded=true

 vm.singleorder.push({idss:doc.id,...doc.data()})

  

        
    })
 

    if( vm.singleorder[0].status=='Cancelled'){
      vm.$router.go(-1)
    }

  })




    this.singdes=false
 
 





 

   },
   methods:{ 
checkstatus(){


 this.$router.replace({ path: `/orderdetails/${this.actualorders[0].orderid}`})

},

gohome(){
      this.$router.replace({ path: '/'})

},
 
async cancelorder(){

    var date=new Date()
 

var vm=this

 
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;



 
 var x=this.filters.filter((itm)=>{
  return itm.selected
 })
 

 




  const citiesRef = fb.db.collection('shop').doc(vm.uids).collection('orders')
  const snapshot = await citiesRef.where('orderid', '==', vm.actualorders[0].orderid).get();
   
  var docids=''
  snapshot.forEach(doc => {
 
 
 
    docids=doc.id

  });
 
  






  let ref=   fb.db.collection('shop').doc(vm.uids).collection('orders') 
 

  await ref.doc(docids).update({
    status:'Cancelled',
    cancelledtime:strTime,
    cancelledreason:x[0].name
  })






 
  
  
   await   fb.db.collection('shopusers').doc(firebase.auth().currentUser.uid).collection('orders').doc(vm.actualorders[0].idss).update({
 
 
              status:'Cancelled',
              cancelledtime:strTime,
                  cancelledreason:x[0].name

            
            }) 




  this.cancelled=true
 


},
 






    filterorder(item){


var y=this.filters.map((itms)=>{

  if(item.name==itms.name){
    return {
      ...itms,
      selected:true
    }
  }else{
     return {
      ...itms,
      selected:false
    }
  }
})
     
 
  
      this.filters=[
      ...y
      ]

      

    },


     account(){


     if(firebase.auth().currentUser){

//alert('yes')


this.$router.push({ path: '/account' })

 }else{
this.loginbox=true
 }
    },
    

    renderdate(timestamp){

      var date=timestamp.toDate();
      var stringdate=date.getDate()+'/'+date.getMonth()+'/'+date.getFullYear()
      var today=new Date()
      var stringtoday=today.getDate()+'/'+today.getMonth()+'/'+today.getFullYear()
         var yesterday=new Date()
      yesterday.setDate(yesterday.getDate() - 1);


      var stringyesterdayday=yesterday.getDate()+'/'+yesterday.getMonth()+'/'+yesterday.getFullYear()
 
 
 

if(stringdate==stringtoday){
 
 return 'Today, '+ date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
 
}else if(stringyesterdayday==stringdate){

 return 'Yesterday, '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

   
}else{
return stringdate+', '+date.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })

}

     

    }

   },
   computed:{
 rendercartlength(){

var cartlength=0
        var x=this.carts.forEach((itm)=>{

           cartlength=Number(itm.quantity)+cartlength
        })
        return cartlength

    },
    actualorders(){

if(this.singdes){

 return this.actualorder=this.singleorder.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })

}else{

    return this.actualorder=this.orders.filter((item)=>{

      return item.orderid==this.$route.params.orderid
    })
    }
  }
   }

    
 
  
}
</script>
<style scoped >
  

</style>
 



// WEBPACK FOOTER //
// src/cancelorder.vue